import React from 'react';
import { ExternalLink } from 'lucide-react';
interface WeddingStory {
  coupleNames: string;
  date: string;
  imageUrl: string;
  instagramUrl: string;
}
export function RealLoveStoriesSection() {
  const stories: WeddingStory[] = [{
    coupleNames: 'Liv & Kenny',
    date: '14th June 2025',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/Liv-Kenny.jpg',
    instagramUrl: 'https://www.instagram.com/petersonhouseweddings/p/DRBxkvQkfEm/?hl=en&img_index=8'
  }, {
    coupleNames: 'Makayla & Jaiden',
    date: '20th August 2025',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/Makayla-Jaiden.jpg',
    instagramUrl: 'https://www.instagram.com/p/DRTzJZTkZ9l/?hl=en&img_index=20'
  }, {
    coupleNames: 'Dharshini & Andrew',
    date: '26th September 2025',
    imageUrl: 'https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/Dharshini-Andrew.jpg',
    instagramUrl: 'https://www.instagram.com/p/DRtmbiGkqnU/?hl=en&img_index=1'
  }];
  return <section className="bg-white py-20 px-8" data-id="element-175">
      <div className="max-w-7xl mx-auto" data-id="element-176">
        {/* Section Header */}
        <div className="text-center mb-12" data-id="element-177">
          <div className="w-16 h-0.5 bg-brand-pink mx-auto mb-6" data-id="element-178" />
          <div className="text-brand-pink text-xs tracking-[0.4em] font-light uppercase mb-4" data-id="element-179">
            Real Weddings
          </div>
          <h2 className="font-heading text-5xl font-normal text-neutral-900 mb-6" data-id="element-180">
            Real Love Stories
          </h2>
          <p className="text-lg text-neutral-600 max-w-3xl mx-auto leading-relaxed" data-id="element-181">
            See how couples have celebrated their special day at Peterson House.
          </p>
        </div>

        {/* Wedding Stories Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-id="element-182">
          {stories.map((story, index) => <a key={index} href={story.instagramUrl} target="_blank" rel="noopener noreferrer" className="group bg-white border border-neutral-200 rounded-none overflow-hidden hover:border-brand-pink transition-colors" data-id="element-183">
              {/* Image */}
              <div className="relative aspect-square bg-gray-300 overflow-hidden" data-id="element-184">
                <img src={story.imageUrl} alt={`${story.coupleNames} wedding`} className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 ${index === 1 ? 'object-bottom' : ''}`} data-id="element-185" />
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300 flex items-center justify-center" data-id="element-186">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white rounded-full p-3" data-id="element-187">
                    <ExternalLink className="w-6 h-6 text-brand-pink" data-id="element-188" />
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 text-center" data-id="element-189">
                <h3 className="font-heading text-xl font-normal text-neutral-900 mb-2" data-id="element-190">
                  {story.coupleNames}
                </h3>
                <p className="text-sm text-neutral-500 mb-4" data-id="element-191">{story.date}</p>
                <div className="inline-flex items-center gap-2 text-brand-pink text-sm font-medium group-hover:gap-3 transition-all" data-id="element-192">
                  View More Photos
                  <ExternalLink size={14} data-id="element-193" />
                </div>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}